<template>
  <section class="app-main" :style="[hiddenSidebarStyle]" style="position: relative;">
    <div :class="{flex: isProductCreate}" style="align-items: flex-start" v-if="ready">
      <product-tab-sidebar v-if="$store.getters.device === 'pc' && $route.path === '/office/admin/product/create'"></product-tab-sidebar>
      <div style="flex:1">
        <required-bar></required-bar>
        <div class="container is-fluid is-marginless app-content">
          <bread-crumb v-if="$store.getters.device !== 'pc' || ($store.getters.device === 'pc' && $route.path !== '/office/admin/product/create')"></bread-crumb>
          <product-reg-bread-crumb v-if="$store.getters.device === 'pc' && $route.path === '/office/admin/product/create'"></product-reg-bread-crumb>
          <transition
            mode="out-in"
            enter-active-class="fadeIn"
            leave-active-class="fadeOut"
            appear>
            <keep-alive :include="availPages">
              <router-view class="animated" v-if="ready"
                          :key="$route.path" style="padding-bottom:80px;min-height: calc(100vh - 150px)"></router-view>
            </keep-alive>
          </transition>
          <div v-if="!ready" style="height:100vh"></div>

          <!-- 로딩 -->
          <div class="lp-loading" v-if="loadingStatus">
            <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
          </div>
          <!-- 로딩 메시지 -->
          <loading></loading>

          <!-- 아웃사이드 -->
          <div class="lp-main-outsider" @click="clickOutSider" v-if="isMobile">

          </div>
        </div>
      </div>
    </div>
    <!-- 푸터 -->
    <admin-footer v-if="!isBuilder && !isLaunchpack"></admin-footer>
    <!--<template v-if="ready && !isLaunchpack">
      <trial-bar></trial-bar>
      <plan-change-modal ref="planChangeModal"></plan-change-modal>
      <modal-trial-review ref="trialReviewModal"></modal-trial-review>
    </template>-->
  </section>
</template>

<script>
import AdminFooter from '../module/common/AdminFooter'
import BreadCrumb from '../module/common/BreadCrumb'
import ProductRegBreadCrumb from '../module/common/ProductRegBreadCrumb'
import ProductTabSidebar from '../module/common/ProductTabSidebar'
import RequiredBar from "../module/common/RequiredBar";
import TrialBar from "../module/common/TrialBar";
import PlanChangeModal from "../page/service/components/PlanChangeModal";
import ModalTrialReview from "../module/modal/ModalTrialReview";
import Loading from "../module/common/Loading";

export default {
  components: {
    Loading,
    ModalTrialReview,
    PlanChangeModal,
    TrialBar,
    RequiredBar,
    AdminFooter,
    BreadCrumb,
    ProductRegBreadCrumb,
    ProductTabSidebar
  },
  data() {
    return {
      ready: false,
      availPages: [
        'ProductList', 'UserList', 'PartnerList', 'ProductReviewNew', 'ProductReviewAll', 'CustomerInquiry',
        'ProductInquiryNew', 'ProductInquiryAll', 'OnetoOneNew', 'OnetoOneAll', 'CallOrderNew', 'CallOrderAll',
        'NoticeList', 'FaqList', 'EventList', 'ExhibitionList', 'BoardList', 'PostList', 'PostMappingList',
        'BannerList', 'PushList', 'GroupList', 'AlbumList', 'AlbumPostList', 'GroupBoardList', 'GroupBoardPostList',
        'GroupDutyList', 'GroupMemberList', 'GroupCalendarList', 'GuideList', 'MeetRequestNew', 'MeetRequestAll',
        'CounselRequestNew', 'CounselRequestAll', 'ServiceInquiry', 'ThemeRequest', 'InternalPluginList',
        'UserParamList', 'PartnerParamList', 'ProductParamList', 'PostParamList', 'UserGradeList', 'PartnerGradeList',
        'PartnerGradeApprovalNew', 'PartnerGradeApprovalAll', 'UserGradeApprovalNew', 'UserGradeApprovalAll',
        'PopupList', 'SuperPartnerList', 'ServiceList', 'PaymentList', 'CouponList',
        'AccountNew', 'AccountAll', 'OrderListNew', 'OrderListAll', 'Form', 'OrderNew', 'OrderAll',
        'RequestNew', 'RequestAll', 'RequestPartner', 'ResponseAll', 'DeliveryNew', 'DeliveryDoing', 'DeliveryAll',
        'PurchaseAll', 'PurchaseNew', 'PurchaseCancelAll', 'PurchaseCancelNew', 'ProductReadyNew', 'ProductReadyAll',
        'DownloadAll', 'DownloadNew', 'NoPassList', 'DeliveryProductList', 'OrderListCancelAll', 'OrderListCancelNew',
        'OrderListDeliveryAll', 'OrderListDeliverying', 'OrderListDeliveryNew', 'OrderListDeliverySuccess',
        'OrderListSettle', 'OrderListExchangeAll', 'OrderListExchangeDeliveryAll', 'OrderListExchangeDeliveryNew',
        'OrderListExchangeGoods', 'OrderListExchangeNew', 'OrderListExchangeSettle', 'OrderListExchangeSuccess',
        'OrderListExchanging', 'OrderListGoodsAll', 'OrderListGoodsNew', 'OrderListOrder', 'OrderListPayAll',
        'OrderListPayNew', 'OrderListRefundAll', 'OrderListRefundNew', 'OrderListReturnAll', 'OrderListReturnNew',
        'OrderListReturning', 'DownloadNew', 'OrderList',
      ]
    }
  },
  computed: {
    isProductCreate() {
      return this.$store.getters.device === 'pc' && this.$route.path === '/office/admin/product/create';
    },
    isBuilder() {
      return this.$store.getters.fromBuilder;
    },
    loadingStatus(){
      return !!this.$store.getters.loading;
    },
    hiddenSidebarStyle(){
      let deco = {};
      if(!this.$store.getters.sidebar) {
        deco.marginLeft = 0;
      }
      if(!this.isBuilder) {
        deco.paddingTop = '50px';
      }
      return deco;
    },
    isMobile(){
      return !!(this.$store.getters.device === 'mobile' && this.$store.getters.sidebar);
    }
  },
  created(){
    this.$store.commit('setLoading', false);
    if(!this.isLaunchpack){
      this.getPanelList();
      this.getServiceSettingProduct();
    }
    this.getServiceSetting();
    this.$root.$on('planChangeModal', () => {

      if(this.serviceInfo.service_type === 4) {
        this.$refs.planChangeModal.open();
      } else {
        let admin = this.$store.getters.admin;
        window.open('https://launchpack.co.kr/theme_detail'+
          `?id=${this.serviceInfo.plan.product.id}&i=${admin.id}&tn=${admin.token}`+
          `&key=${this.$store.getters.getServiceSetting.service_key}`+
          `&s=${this.$store.getters.masterService.id}`);
      }
    });
    this.$root.$on('trialReviewModal', () => {
      this.$refs.trialReviewModal.open();
    });
  },
  methods:{
    // 판넬 설정 리스트 가져와서 Store에 저장
    getPanelList() {
      if(this.$store.getters.mode!=='superpartner') {
        let url = 'panel/setting';
        if(this.$store.getters.mode==='supervisor') {
          url = 'admin/panel/setting';
        } else {
          url = this.getUrl(url)
        }
        this.$axios.get(url).then(res=>{
          this.$store.commit('setPanel', res.data);
        })
      }
    },
    // 서비스 설정 가져오기
    getServiceSettingProduct() {
      this.$axios.get('public/service/setting/product').then(res=>{
        this.$store.commit('setServiceSettingProduct', res.data);
      })
    },
    getServiceSetting() {
      this.$axios.get('public/service/setting').then(res=>{
        this.$store.commit('setServiceSetting', res.data);
        this.ready = true;
        /*if(!this.isLaunchpack) {
          this.regServiceAdminToken();
        }*/
      })
    },
    clickOutSider(){
      this.$store.commit('setSideBar', false);
    },
    // serviceadmin token 생성
    regServiceAdminToken() {
      let admin = this.$store.getters.admin;
      if(admin) {
        let params = {
          service_key: this.$store.getters.getServiceSetting.service_key,
          token: admin.token
        }
        this.$axios.post(`${this.masterBackendUrl}serviceadmin/${admin.id}`, params)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/mixins';

.app-main {
  margin-left: 230px;
  //transform: translate3d(0, 0, 0);
  background-color: #e9e9e9;
  min-height:100vh;

  @include mobile() {
    margin-left: 0;
  }

}

.lp-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;

  i {
    position: fixed;
    top: 50%;
  }
}

.app-content {
  padding: 20px;
}

.lp-main-outsider {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 120;
  background: rgba(0,0,0, 0.3);
}

.container {
  width: 100%;
}
</style>
